import { ocapiClient } from '../../../api-clients/ocapi/client';
import { createOrGetFetchedState } from '../../../utils/fetched-data/create-or-get-fetched-state';
import { getCacheDuration } from '../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../utils/load-data-from-api';
import { journeyDomainStore } from '../store';
import { onJourneyLoadSuccess } from './utils/on-journey-load-success';
export const loadJourneyForOrder = async (orderId, reloadCachedData) => {
    const state = createOrGetFetchedState(journeyDomainStore.data.journeysByOrderId, orderId);
    await loadDataFromApi({
        api: () => ocapiClient.instance.v1.journeys.getForCompletedOrder(orderId),
        state,
        cacheDuration: getCacheDuration('journeys'),
        onSuccess: onJourneyLoadSuccess,
        reloadCachedData
    });
};
